import { render, staticRenderFns } from "./FirstAidVideo_list.vue?vue&type=template&id=f0b3216e&scoped=true&"
import script from "./FirstAidVideo_list.vue?vue&type=script&lang=js&"
export * from "./FirstAidVideo_list.vue?vue&type=script&lang=js&"
import style0 from "./FirstAidVideo_list.vue?vue&type=style&index=0&id=f0b3216e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b3216e",
  null
  
)

export default component.exports